import { render, staticRenderFns } from "./SettingsPage.vue?vue&type=template&id=4398794f&scoped=true&"
import script from "./SettingsPage.vue?vue&type=script&lang=js&"
export * from "./SettingsPage.vue?vue&type=script&lang=js&"
import style0 from "./SettingsPage.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./SettingsPage.vue?vue&type=style&index=1&id=4398794f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4398794f",
  null
  
)

export default component.exports